import SuiteDashboard from '@/components/Suite/SuiteDashboard.vue'
import SuiteLogin from '@/components/Suite/SuiteLogin.vue'

export default [
    {
        path: '/',
        name: 'suite_dashboard',
        component: SuiteDashboard,
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'suite_login',
        component: SuiteLogin,
        meta: { requiresAuth: false }
    }
]
